var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("label", { staticClass: "col-form-label pt-0" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _c(
        "b-nav-item-dropdown",
        {
          attrs: {
            text: _vm.__(_vm.text, ["truncate"]),
            "extra-toggle-classes": "navbar-filter",
            "extra-menu-classes": "w-100 overflow-y-auto",
            left: ""
          }
        },
        [
          _vm.config.searchable
            ? [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search"
                    }
                  ],
                  staticClass: "form-control",
                  staticStyle: { width: "96%", "margin-left": ".325rem" },
                  attrs: { type: "text", placeholder: "Search" },
                  domProps: { value: _vm.search },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.search = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("hr")
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-dropdown-item",
            {
              on: {
                click: function($event) {
                  return _vm.onSelect(null)
                }
              }
            },
            [_vm._v("-- All --")]
          ),
          _vm._v(" "),
          _vm.initialized
            ? _vm._l(_vm.filteredValues, function(value) {
                return _c(
                  "b-dropdown-item",
                  {
                    key: value.id,
                    on: {
                      click: function($event) {
                        return _vm.onSelect(value)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.__(value.name, ["titleCase"])))]
                )
              })
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-630bc2f1", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-630bc2f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/CustomFilterComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-630bc2f1","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/helpers/CustomFilterComponent.vue
// module chunks = 0